/**
 * Sort options for orders search
 */
var OrdersServiceSort;
(function (OrdersServiceSort) {
    // Default/recent orders first
    OrdersServiceSort["RECENT_FIRST"] = "recent-first";
    // Order ID sorting
    OrdersServiceSort["ORDER_ID_ASC"] = "order-id-asc";
    OrdersServiceSort["ORDER_ID_DESC"] = "order-id-desc";
    // Buyer name sorting
    OrdersServiceSort["BUYER_ASC"] = "buyer-asc";
    OrdersServiceSort["BUYER_DESC"] = "buyer-desc";
    // Orders table tab sorting
    OrdersServiceSort["ORDERS_TABLE_TAB_ASC"] = "orders-table-tab-asc";
    OrdersServiceSort["ORDERS_TABLE_TAB_DESC"] = "orders-table-tab-desc";
    // Date sorting
    OrdersServiceSort["ORDER_DATE_ASC"] = "order-date-asc";
    OrdersServiceSort["ORDER_DATE_DESC"] = "order-date-desc";
    // Vehicle name sorting
    OrdersServiceSort["VEHICLE_ASC"] = "vehicle-asc";
    OrdersServiceSort["VEHICLE_DESC"] = "vehicle-desc";
    // PG&A (Parts, Garments & Accessories) sorting
    OrdersServiceSort["PGA_ASC"] = "pga-asc";
    OrdersServiceSort["PGA_DESC"] = "pga-desc";
    // F&I (Finance & Insurance) sorting
    OrdersServiceSort["FI_ASC"] = "fi-asc";
    OrdersServiceSort["FI_DESC"] = "fi-desc";
    // F&I PRU (Finance & Insurance Per Retail Unit) sorting
    OrdersServiceSort["FI_PRU_ASC"] = "fi-pru-asc";
    OrdersServiceSort["FI_PRU_DESC"] = "fi-pru-desc";
    // Total price sorting
    OrdersServiceSort["TOTAL_ASC"] = "total-asc";
    OrdersServiceSort["TOTAL_DESC"] = "total-desc";
    // Payment choice sorting
    OrdersServiceSort["PAYMENT_CHOICE_ASC"] = "payment-choice-asc";
    OrdersServiceSort["PAYMENT_CHOICE_DESC"] = "payment-choice-desc";
    // Payment status sorting
    OrdersServiceSort["PAYMENT_STATUS_ASC"] = "payment-status-asc";
    OrdersServiceSort["PAYMENT_STATUS_DESC"] = "payment-status-desc";
    // Financing status sorting
    OrdersServiceSort["FINANCING_STATUS_ASC"] = "financing-status-asc";
    OrdersServiceSort["FINANCING_STATUS_DESC"] = "financing-status-desc";
    // Registration state sorting
    OrdersServiceSort["REG_STATE_ASC"] = "reg-state-asc";
    OrdersServiceSort["REG_STATE_DESC"] = "reg-state-desc";
    // VIN sorting
    OrdersServiceSort["VIN_ASC"] = "vin-asc";
    OrdersServiceSort["VIN_DESC"] = "vin-desc";
    // Fulfillment type sorting
    OrdersServiceSort["FULFILLMENT_TYPE_ASC"] = "fulfillment-type-asc";
    OrdersServiceSort["FULFILLMENT_TYPE_DESC"] = "fulfillment-type-desc";
    // Fulfillment date sorting
    OrdersServiceSort["FULFILLMENT_DATE_ASC"] = "fulfillment-date-asc";
    OrdersServiceSort["FULFILLMENT_DATE_DESC"] = "fulfillment-date-desc";
    // Tasks sorting
    OrdersServiceSort["TASKS_ASC"] = "tasks-asc";
    OrdersServiceSort["TASKS_DESC"] = "tasks-desc";
})(OrdersServiceSort || (OrdersServiceSort = {}));

export { OrdersServiceSort };
//# sourceMappingURL=OrdersServiceSort.js.map
